var _path, _a;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.53793 14H0.813322V5.24023H3.53793V14ZM2.16098 4.06836C1.31137 4.06836 0.608244 3.33594 0.608244 2.45703C0.608244 1.60742 1.31137 0.904297 2.16098 0.904297C3.03988 0.904297 3.74301 1.60742 3.74301 2.45703C3.74301 3.33594 3.03988 4.06836 2.16098 4.06836ZM13.7039 14H11.0086V9.75195C11.0086 8.72656 10.9793 7.4375 9.57309 7.4375C8.16684 7.4375 7.96176 8.52148 7.96176 9.66406V14H5.23715V5.24023H7.84457V6.44141H7.87387C8.25473 5.76758 9.13363 5.03516 10.452 5.03516C13.2059 5.03516 13.7332 6.85156 13.7332 9.19531V14H13.7039Z",
    fill: "#050B20"
  })), _a || (_a = /*#__PURE__*/React.createElement("a", {
    href: "https://www.figma.com/design/PzQUNVEIeMrv8HjdXbjYra?node-id=13-779"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "black",
    fillOpacity: 0,
    x: 0.178312,
    y: -1.125,
    width: 13.125,
    height: 17.25
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.30f06198dc569123b4a7bcc7a9c442a2.svg";
export { ForwardRef as ReactComponent };